import { Outlet } from "react-router-dom";
import { useState } from "react";
import VolunteerSidebar from "./VolunteerSidebar";
import LogoutWatcher from "../../Utils/LogoutWatcher";
import Header from "../../MainDashboard/Header";
import { useGlobalContext } from "../../../GlobalContext";

export default function VolunteerLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { showOld, setShowOld } = useGlobalContext();

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      
      {/* Logout Watcher */}
      <LogoutWatcher type="volunteer" />

      {/* Header */}
      <Header
        showOld={showOld}
        setShowOld={setShowOld}
      />

      {/* Main Content Area */}
      <div className="flex flex-1 overflow-hidden">

        {/* Sidebar */}
        <VolunteerSidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />

        {/* Page Content */}
        <div className="flex-1 overflow-auto bg-gray-50 p-4">
          <Outlet />
        </div>

      </div>
    </div>
  );
}
